import React from 'react'
import { useMount } from 'react-use'

import { Heading } from '@/components/ui/heading'
import { Spinner } from '@/components/ui/spinner'
import authService from '@/lib/services/authService'

const InvalidUserContextErrorMessage: React.FC = () => {
  useMount(() => {
    authService.logout()
  })

  return (
    <>
      <Heading size={2}>Session expired</Heading>

      <div className="text-md flex items-center gap-2">
        <p className="mb-0">Your session has expired. Logging you out...</p>
        <Spinner />
      </div>
    </>
  )
}

export default InvalidUserContextErrorMessage
